export const BUILD_VERSION = 'f52fda15a3e8b1696d3fd3ea79236b5399c1f3e5';
